import SiteNavbar from "@/components/feature/SiteNavbar";
import SiteFooter from "@/components/feature/SiteFooter";
import SectionHeading from "@/components/feature/SectionHeading";
import HeroCarousel from "./components/HeroCarousel";
import QuickCategoryStrip from "./components/QuickCategoryStrip";
import LatestUpdates from "./components/LatestUpdates";
import HotTags from "./components/HotTags";
import CategoryGrid from "./components/CategoryGrid";
import PopularGrid from "./components/PopularGrid";
import { Link } from "react-router-dom";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteNavbar />

      <main className="flex-1 w-full">
        <section aria-label="焦点推荐">
          <HeroCarousel />
        </section>

        <div className="mx-auto max-w-page px-4 md:px-8">
          <div className="-mt-8 md:-mt-12 relative z-20">
            <QuickCategoryStrip />
          </div>

          <section className="mt-10 md:mt-14">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
              <div className="lg:col-span-2">
                <SectionHeading
                  title="最新更新"
                  subtitle="最近上架的国语对白影音资源"
                  moreLink="/search"
                  moreText="全部资源"
                />
                <LatestUpdates />
              </div>
              <div className="lg:col-span-1 flex flex-col gap-6">
                <HotTags />
                <div className="rounded-lg border border-background-200 bg-primary-950 p-5 text-background-100">
                  <i className="ri-information-line text-2xl text-accent-400" />
                  <h3 className="mt-3 text-base font-semibold text-background-50 font-heading">站内检索说明</h3>
                  <p className="mt-2 text-xs leading-relaxed text-background-300">
                    支持按标题、简介、主创与标签关键词检索，也可进入分类页按地区、年份、类型多维筛选，快速定位你感兴趣的国语影音作品。
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="mt-12 md:mt-16">
            <SectionHeading
              title="精选分类"
              subtitle="按题材进入对应资源合集"
              moreLink="/search"
              moreText="浏览全部"
            />
            <CategoryGrid />
          </section>

          <section className="mt-12 md:mt-16">
            <SectionHeading
              title="热门推荐"
              subtitle="近期最受关注的国语对白影音作品"
              moreLink="/category/tv"
              moreText="更多剧集"
            />
            <PopularGrid />
          </section>

          <section className="mt-12 md:mt-16 mb-14 md:mb-20">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8 rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
              <div className="lg:col-span-2">
                <h2 className="text-lg md:text-xl font-bold text-foreground-950 font-heading">
                  关于国语对白做受69
                </h2>
                <p className="mt-3 text-sm text-foreground-700 leading-relaxed">
                  国语对白做受69 致力于为中文用户整理和呈现优质的国语对白影音资源。我们通过专业的分类体系与多维筛选，
                  把电影、电视剧、纪录片、综艺、动漫与微电影等不同类型的内容清晰地组织在一起，方便你按兴趣浏览与了解。
                </p>
                <p className="mt-3 text-sm text-foreground-700 leading-relaxed">
                  站内提供作品资料介绍、标签导航与同类推荐，帮助你发现更多可能感兴趣的作品。
                  所有内容均用于展示与介绍，本平台不提供播放、下载、会员及支付等在线服务。
                </p>
                <div className="mt-5 flex flex-wrap gap-3">
                  <Link
                    to="/about"
                    className="inline-flex items-center gap-1.5 rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    了解更多
                    <i className="ri-arrow-right-line" />
                  </Link>
                </div>
              </div>
              <div className="lg:col-span-1 grid grid-cols-2 gap-4">
                <div className="rounded-lg bg-background-50 border border-background-200 p-4">
                  <p className="text-2xl font-bold text-primary-600 font-heading">460+</p>
                  <p className="mt-1 text-xs text-foreground-500">影音资源收录</p>
                </div>
                <div className="rounded-lg bg-background-50 border border-background-200 p-4">
                  <p className="text-2xl font-bold text-accent-600 font-heading">6</p>
                  <p className="mt-1 text-xs text-foreground-500">专业分类板块</p>
                </div>
                <div className="rounded-lg bg-background-50 border border-background-200 p-4">
                  <p className="text-2xl font-bold text-primary-600 font-heading">3</p>
                  <p className="mt-1 text-xs text-foreground-500">多维筛选维度</p>
                </div>
                <div className="rounded-lg bg-background-50 border border-background-200 p-4">
                  <p className="text-2xl font-bold text-accent-600 font-heading">99%</p>
                  <p className="mt-1 text-xs text-foreground-500">国语对白覆盖</p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}